/* eslint-disable no-console */
import { register } from 'register-service-worker'
import store from '@/store'

const isDev = process.env.NODE_ENV !== 'production'
const devLog = (...args) => { if (isDev) console.log(...args) }
const devErr = (...args) => { if (isDev) console.error(...args) }

/* ---------- optional: broadcast FIREBASE config to the SW ---------- */
function postFirebaseConfigToSWs() {
  const cfg = (window.__APP_CONFIG__ && window.__APP_CONFIG__.FIREBASE) || null
  if (!cfg || !('serviceWorker' in navigator)) return
  const msg = { type: 'FIREBASE_CONFIG', payload: cfg }

  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(msg)
  }
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg?.active?.postMessage(msg))
  })
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    navigator.serviceWorker.controller?.postMessage(msg)
  })
}

/** Enable/disable SW debug logs (paired with SW handler for type: 'SW_DEBUG') */
function setSWDebugLogging(enabled) {
  if (!('serviceWorker' in navigator)) return
  const msg = { type: 'SW_DEBUG', payload: !!enabled }
  if (navigator.serviceWorker.controller) {
    navigator.serviceWorker.controller.postMessage(msg)
  }
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(reg => reg?.active?.postMessage(msg))
  })
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    navigator.serviceWorker.controller?.postMessage(msg)
  })
}

/* ---------- Throttled refresher ---------- */
let lastRefreshAt = 0
const MIN_GAP_MS = 3000
let refreshTimer
function refreshNotifications() {
  const now = Date.now()
  if (now - lastRefreshAt < MIN_GAP_MS) return
  lastRefreshAt = now

  clearTimeout(refreshTimer)
  refreshTimer = setTimeout(() => {
    store.dispatch('notification/fetchNotifications', {
      page: 1,
      per_page: 6,
      order: 'desc',
      unread: 'unread',
    }).catch(() => {})
  }, 150)
}

/* ---------- Attach SW → page message listener ONCE ---------- */
if ('serviceWorker' in navigator && !window.__SW_MSG_LISTENER_ATTACHED__) {
  window.__SW_MSG_LISTENER_ATTACHED__ = true
  navigator.serviceWorker.addEventListener('message', e => {
    const data = e.data || {}
    if (data.type === 'SW_LOG') {
      devLog('[SW]', ...(data.payload || []))
      return
    }
    if (data.type === 'FCM_BACKGROUND_MESSAGE' || data.type === 'FCM_NOTIFICATION_CLICK') {
      refreshNotifications()
    }
  })
}

/* ---------- Post config & toggle SW logging on load and once ready ---------- */
if ('serviceWorker' in navigator) {
  postFirebaseConfigToSWs()
  setSWDebugLogging(isDev)
  navigator.serviceWorker.ready
    .then(() => {
      postFirebaseConfigToSWs()
      setSWDebugLogging(isDev)
    })
    .catch(() => {})
}

/* ---------- Register the service worker  ---------- */

register(`${process.env.BASE_URL}service-worker.js`, {
  ready() { devLog('SW ready'); postFirebaseConfigToSWs(); setSWDebugLogging(isDev) },
  registered() { devLog('SW registered'); postFirebaseConfigToSWs(); setSWDebugLogging(isDev) },
  cached() { devLog('Content cached for offline use.') },
  updatefound() { devLog('New content is downloading.') },
  updated() { devLog('New content is available; please refresh.') },
  offline() { devLog('No internet connection found. App is running in offline mode.') },
  error(error) { devErr('SW registration error:', error) },
})
